import React from 'react';
import { XCircle, ArrowRight } from 'lucide-react';
import { Button } from './Button';
export function PainPoints() {
  const points = ['Corrales incómodos que hacen perder tiempo todos los días.', 'Animales que se frenan, se amontonan o se estresan constantemente.', 'Instalaciones improvisadas que dificultan vacunaciones, apartes y carga.', 'Horas perdidas moviendo animales por sistemas mal distribuidos.', 'Miedo a gastar plata construyendo algo que después no funciona bien.', 'Diseños encontrados en internet que no se adaptan a tu realidad productiva.'];
  const failedSolutions = [{
    title: 'Videos de YouTube',
    desc: 'Mucho contenido suelto y poca aplicación real.'
  }, {
    title: 'Diseños encontrados en internet',
    desc: 'La mayoría no se adapta a tu espacio ni a tu manejo.'
  }, {
    title: 'Copiar corrales de otros productores',
    desc: 'Lo que funciona en otro campo puede no servir en el tuyo.'
  }, {
    title: 'Improvisar sobre la marcha',
    desc: 'Termina generando más trabajo, más estrés y más pérdidas.'
  }];
  return <section className="py-10 md:py-14 px-4 bg-black" data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <h2 className="text-xl md:text-3xl font-display font-bold text-center mb-6 text-white uppercase leading-tight" data-id="element-134">
          Si trabajás con ganado, esto probablemente{' '}
          <span className="highlight-yellow" data-id="element-135">te resulte familiar:</span>
        </h2>

        <div className="bg-zinc-900 border-l-4 border-brand-red rounded-r-lg shadow-2xl p-4 md:p-6 mb-8 border-y border-r border-zinc-800" data-id="element-136">
          <ul className="space-y-2.5" data-id="element-137">
            {points.map((point, index) => <li key={index} className="flex items-start" data-id="element-138">
                <XCircle className="w-5 h-5 text-brand-red mr-2.5 shrink-0 mt-0.5" data-id="element-139" />
                <p className="text-sm md:text-base text-zinc-200 font-medium leading-relaxed" data-id="element-140">
                  {point}
                </p>
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-10" data-id="element-141">
          <p className="text-base md:text-2xl font-display font-bold text-white leading-tight" data-id="element-142">
            ¿Cuánto tiempo y esfuerzo más vas a seguir perdiendo por trabajar
            con <span className="highlight-green" data-id="element-143">un sistema incómodo?</span>
          </p>
        </div>

        {/* Failed solutions */}
        <div className="mb-10" data-id="element-144">
          <h3 className="text-lg md:text-2xl font-display font-bold text-center mb-1 text-white uppercase" data-id="element-145">
            Lo que ya intentaste —
          </h3>
          <p className="text-sm md:text-lg text-center text-brand-red font-bold mb-6" data-id="element-146">
            y por qué no alcanzó
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-147">
            {failedSolutions.map((item, i) => <div key={i} className="bg-zinc-900 border-2 border-brand-red/30 rounded-lg p-4 flex items-start" data-id="element-148">
                <span className="text-xl text-brand-red font-black mr-2.5 leading-none" data-id="element-149">
                  ✗
                </span>
                <div data-id="element-150">
                  <h4 className="font-display font-bold text-base text-white mb-0.5" data-id="element-151">
                    {item.title}
                  </h4>
                  <p className="text-xs md:text-sm text-zinc-400" data-id="element-152">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Mid-page persuasive CTA */}
        <div className="bg-gradient-to-br from-zinc-900 to-zinc-950 border-2 border-brand-green rounded-xl p-5 md:p-6 text-center shadow-2xl glow-green" data-id="element-153">
          <p className="text-base md:text-xl font-display font-bold text-white mb-2 uppercase leading-tight" data-id="element-154">
            👉 Hay una forma más inteligente de hacer esto
          </p>
          <p className="text-xs md:text-sm text-zinc-300 mb-4 max-w-xl mx-auto" data-id="element-155">
            Mirá el sistema que ya usan más de 2.300 productores para dejar de
            improvisar y empezar a trabajar mejor todos los días.
          </p>
          <div className="max-w-sm mx-auto" data-id="element-156">
            <Button className="text-sm md:text-base py-2.5 md:py-3" data-id="element-157">
              <ArrowRight className="w-4 h-4 mr-1.5" data-id="element-158" />
              QUIERO VER EL SISTEMA AHORA
            </Button>
          </div>
        </div>
      </div>
    </section>;
}